// Modal.js
import React from 'react';
 // Add your styles

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) {
    return null; // Do not render if not open
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={onClose}>X</button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
